import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type UnavailableProps = {
    className?: string;
};

const Unavailable: FunctionComponent<UnavailableProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'unavailable'}
            viewBox="0 0 250 26"
        >
            <path
                d="M0 15.7V.4h2.2v15.2c0 5 2.6 8.1 7.5 8.1s7.5-3 7.5-8.1V.4h2.2v15.3c0 6.1-3.3 10-9.7 10-6.4-.1-9.7-3.9-9.7-10z"
                className="st0"
            />
            <path
                d="M45.5 25.2L29.8 3.9v21.3h-2.1V.4h2.2l15.5 21V.4h2.1v24.8h-2z"
                className="st0"
            />
            <path
                d="M73.9 25.2l-2.5-6.1H58.3l-2.5 6.1h-2.5L63.6.4h2.6l10.1 24.8h-2.4zm-9-22.6L59 17.1h11.7L64.9 2.6z"
                className="st0"
            />
            <path d="M87.7 25.2L77.6.4H80l9 22.4L98 .4h2.5L90.3 25.2h-2.6z" className="st0" />
            <path
                d="M122.2 25.2l-2.5-6.1h-13.1l-2.5 6.1h-2.5L111.7.4h2.6l10.1 24.8h-2.2zm-9-22.6l-5.8 14.5H119l-5.8-14.5z"
                className="st0"
            />
            <path d="M130.5 25.2V.4h2.1v24.8h-2.1z" className="st0" />
            <path d="M141 25.2V.4h2.1v22.9h12v1.9H141z" className="st0" />
            <path
                d="M179.9 25.2l-2.5-6.1h-13.1l-2.5 6.1h-2.5L169.4.4h2.6l10.1 24.8h-2.2zm-9-22.6l-5.8 14.5h11.7l-5.9-14.5z"
                className="st0"
            />
            <path
                d="M188.3 25.2V.4h10.2c4.2 0 6.8 2.4 6.8 6.3 0 3.1-2.1 5.2-4.3 5.7 2.6.4 4.8 3.2 4.8 6.1 0 4.1-2.7 6.7-7.1 6.7h-10.4zm14.8-18.3c0-2.5-1.7-4.6-4.9-4.6h-7.8v9.2h7.8c3.2 0 4.9-2 4.9-4.6zm.4 11.4c0-2.5-1.7-4.9-5.2-4.9h-8v9.8h8c3.3 0 5.2-1.9 5.2-4.9z"
                className="st0"
            />
            <path d="M213.3 25.2V.4h2.1v22.9h12v1.9h-14.1z" className="st0" />
            <path
                d="M234.3 25.2V.4H250v1.9h-13.6v9.2h13.3v1.9h-13.3v9.8H250v1.9h-15.7z"
                className="st0"
            />
        </svg>
    );
};

export default Unavailable;
